import { render, staticRenderFns } from "./Switcher.vue?vue&type=template&id=617f3951&scoped=true&"
import script from "./Switcher.vue?vue&type=script&lang=js&"
export * from "./Switcher.vue?vue&type=script&lang=js&"
import style0 from "./Switcher.vue?vue&type=style&index=0&id=617f3951&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617f3951",
  null
  
)

export default component.exports